import { Helmet } from 'react-helmet-async';

const DOMAIN = 'https://avicement.com';

/**
 * SEOHead — Injects per-page <title>, <meta description>, <link canonical>,
 * and optional noindex/nofollow into the document <head>.
 *
 * Usage:
 *   <SEOHead
 *     title="Products | Avi Cement"
 *     description="Explore our 12 products..."
 *     path="/products"
 *   />
 */
const SEOHead = ({
  title,
  description,
  path = '/',
  noindex = false,
  ogImage = '/og-image.jpg',
  ogType = 'website',
  jsonLd = null,
}) => {
  const canonical = `${DOMAIN}${path}`;
  const fullTitle = title ? `${title} | Avi Cement Limited` : 'Avi Cement Limited | Building India Since 2004';

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description || 'Avi Cement Limited — Premium cement, AAC blocks, construction chemicals. 750+ dealers across Gujarat & Rajasthan.'} />
      <link rel="canonical" href={canonical} />

      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || 'Premium cement and construction materials by Avi Cement Limited.'} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={`${DOMAIN}${ogImage}`} />
      <meta property="og:site_name" content="Avi Cement Limited" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description || 'Premium cement and construction materials by Avi Cement Limited.'} />
      <meta name="twitter:image" content={`${DOMAIN}${ogImage}`} />

      {/* JSON-LD */}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
};

export default SEOHead;
